export function memoize<T1, TResult>(fn: (arg1: T1) => TResult): (arg1: T1) => TResult {
    const cache: any = Object.create(null);

    return (arg: T1) => cache[arg] || (cache[arg] = fn(arg));
}